// extracted by mini-css-extract-plugin
export default {"spantxt":"TxtValues_spantxt__8BLcE","title":"TxtValues_title__oCFVb","values":"TxtValues_values__PY3si","animate-rotate":"TxtValues_animate-rotate__gtQ4H"};